import { html, render } from 'lit-html';

import { status as loggedin, loginButtonHandler } from '../auth.js';
import { chatButtonHandler } from './chat.js';

import { showing, showContent } from '../sidebar.js';
import { freebiesButtonHandler } from './freebies.js';

import { replayButtonHandler } from './replay.js';

const BUTTON_SELECTOR='[data-action="go-home"]';
const controlSidebar = document.querySelector(BUTTON_SELECTOR);
if (controlSidebar) {
  controlSidebar.addEventListener('click', goHomeButtonHandler);
}

const signupBtn = (e) => {
  e.preventDefault();
  window.open('https://rustfest.global/information/tickets/','_blank')
}

export const tHomepageIntro = (p) => {
  if (loggedin()) return tHomepageIntroAuthed(p);

  return html`
<div class="sidebar-content c-homepage-intro">
<h2>Welcome back to RustFest Global!</h2>

<p>Enjoy the talks, live streaming sessions and arts performances, brought to you by the global Rust community.</p>

<button class="sbc" @click=${signupBtn}>Get a ticket!</button>

<h3>Already got a ticket?</h3>

<button class="sbc" @click=${loginButtonHandler}>Log in</button>
<button class="sbc" disabled>Chat</button>
<button class="sbc" disabled>Freebies</button>
<button class="sbc" disabled>Replays</button>

</div>`;
}

export const tHomepageIntroAuthed = (p) => {
  const u = loggedin();
  return html`
<div class="sidebar-content c-homepage-intro authed">
<h2>Welcome to the RustFest Global Event Experience, powered by Waasabi.</h2>

<p>For this year's event we have been working hard on an upgraded
  event experience based on the
  <a href="https://waasabi.org">Waasabi project</a>,
  for which RustFest Global 2020 was the primordial testing ground.</p>

<p>Unfortunately shortly before the event we have discovered serious
  show-stopper issues during the final testing of the new experience.
  As a result, we have made the decision to roll back to last year's
  Live Experience experience for the Rust in Arts event.
  Unfortunately (or fortunately), the two codebases
  have diverged sufficiently to make this switch anything less than
  challenging, so we focused on restoring the feature most important
  to having an online conference: the live stream.</p>

<p>We have also re-established the replay feature which will work in the
  interim before we can fully enable and transition to the new version of
  the streaming experience (ideally and according to plan, before the
  RustFest Global APAC Edition takes place in a couple weeks</p>

<p>Thank you for bearing with us as we experiment with pushing
  the boundaries of online events and bringing the Rust community
  together — and of course, thank you for your support!
</p>

<h3>Hello ${u.name}</h3>

<!--<button class="sbc" @click=${chatButtonHandler}>Chat</button>
<button class="sbc" @click=${freebiesButtonHandler}>Freebies</button>-->
<button class="sbc" @click=${replayButtonHandler}>Replays</button>
<em>*All talks will be available on-demand right after they were streamed live.
<a href="https://rustfest.global/information/how-to-watch/#replays">Learn more.</a></em>

</div>`;
}

export function goHomeButton(p) {
  const frag = document.createDocumentFragment();

  render(html`
<button class="sbc" @click=${goHomeButtonHandler}>&lt; back</button>
  `, frag);

return frag;
}

export function goHomeButtonHandler(e) {
  e.preventDefault();
  showHome();
}

export function showHome() {
  showContent(tHomepageIntro({}), true, false);
}

// Render intro into sidebar content and open it!
setTimeout(
  () => {
    if (!showing()) showHome()
  }
, 10);
